import { motion, useTime, useTransform } from "framer-motion";
import React from "react";
import { TripItemType } from "src/utils/ApiSchema";

interface Props {
  type: TripItemType;
  completed: boolean;
  hover: boolean;
}

function GradientBorder(props: Props) {
  const time = useTime();
  const rotate = useTransform(time, [0, 4000], [0, 360], {
    clamp: false,
  });
  const rotatingBg = useTransform(
    rotate,
    (r) =>
      `linear-gradient(${r}deg,
        #6DA8FF 21.3%,
        rgba(66, 210, 210, 0.16) 54.82%,
        rgba(19, 255, 161, 0.88) 91.2%)`
  );

  return (
    <motion.div
      className={`${props.completed ? "hidden" : "block"} absolute inset-0 -z-30 rounded-[22px] border-white md:${props.hover && !props.completed ? "block" : "hidden"}`}
      style={{
        background:
          (props.type === TripItemType.Background) || props.completed
            ? rotatingBg
            : "transparent",
        borderWidth:
          props.type === TripItemType.Background || props.completed ? 0 : 2,
      }}
    />
  );
}

export default GradientBorder;
